import { useCurrentCompany } from './useCurrentCompany';
import { useCurrentUserScopeForCompany } from './useCurrentUserScopeForCompany';

export const useCurrentUserScopeForCurrentCompany = (): {
  isNonFinancial: boolean;
  isPiiRedacted: boolean;
  limitAccessToFinancialData: boolean;
} => {
  const { company } = useCurrentCompany();
  return useCurrentUserScopeForCompany(company);
};
